import { useState, useEffect, type ReactNode, type FC } from 'react';

import { getStoreValue } from 'pixel-react';

import { AuthContext } from './authContext'; // Import the AuthContext

export const AuthProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null); // Track loading state as null
  const [loading, setLoading] = useState<boolean>(true); // Loading state to control when authentication check is complete

  useEffect(() => {
    const fetchAuthToken = async () => {
      const token = await getStoreValue('auth_token');
      setIsAuthenticated(!!token); // Set to true or false based on token presence
      setLoading(false); // Mark as finished loading
    };

    fetchAuthToken();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Show loading state while authentication is being checked
  }

  // Set isAuthenticated to false if it's still null, for context consumers
  return (
    <AuthContext.Provider value={{ isAuthenticated: isAuthenticated ?? false }}>
      {children}
    </AuthContext.Provider>
  );
};
